import { render, staticRenderFns } from "./ModalFinalizarCompra.vue?vue&type=template&id=745870a6&scoped=true"
import script from "./ModalFinalizarCompra.vue?vue&type=script&lang=js"
export * from "./ModalFinalizarCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745870a6",
  null
  
)

export default component.exports